// Тест по авторам - старт
// Из событий
// Увеличивающие

export const allWeightCoefGroups = [
    {
        name: "testByAuthors",
        title: "Тест по авторам - старт",
        items: [
            {
                name: "AUTHOR_COUNTRY",
                title: "Страна автора",
                description: "Автор события из той же страны, что и любимый"
            },
            /*{
                name: "???",
                title: "???",
                description: "Род деятельности авторов онбординга и своих"
            },*/
            {
                name: "CUSTOM_AUTHOR",
                title: "Пользовательский автор",
                description: "вес для автора, добавленного вручную (не из справочника)"
            },
            {
                name: "EXACT_AUTHOR_MATCH",
                title: "Совпадение по автору",
                description: "Автор из онбординга есть среди авторов события"
            },
        ],
    },
    {
        name: "testByAuthorTags",
        title: "Тест по авторам (теги) - старт",
        items: [
            {
                name: "AUTHOR_TAG_OCCUPATION",
                title: "Род деятельности",
                description: "Совпадение по роду деятельности выбранных/близких авторов"
            },
            {
                name: "AUTHOR_TAG_ART_GENRE",
                title: "Жанр (искусствоведение)",
                description: "Совпадение по искусствоведческому жанру выбранных/близких авторов"
            },
            {
                name: "AUTHOR_TAG_MOVEMENT",
                title: "Направление / стиль",
                description: "Совпадение по направлению или стилю выбранных/близких авторов"
            },
            {
                name: "AUTHOR_TAG_ASSOCIATION",
                title: "Творческие объединения",
                description: "Совпадение по творческим объединениям выбранных/близких авторов"
            },
            {
                name: "AUTHOR_TAG_OTHER",
                title: "Другие теги авторов",
                description: "Совпадение по остальным тегам выбранных/близких авторов, не вошедшим в рубрики выше"
            },
        ],
    },
    {
        name: "fromEvents",
        title: "Из событий",
        items: [
            {
                name: "LIKED_AUTHOR",
                title: "Любимые авторы",
                description: "Ранее понравившийся автор в составе события"
            },
            {
                name: "LIKED_CHOREOGRAPHER",
                title: "Любимые хореографы",
                description: "Понравившийся хореограф у события"
            },
            {
                name: "LIKED_DIRECTOR",
                title: "Любимые режиссёры",
                description: "Понравившийся режиссёр ставит событие"
            },
            /*{
                name: "???",
                title: "???",
                description: "любимый тип события (для театра и музыкального театра"
            },*/
            {
                name: "LIKED_EVENT_SPHERE",
                title: "Любимые сферы (для музеев)",
                description: "Совпадение по интересным пользователю сферам"
            },
            {
                name: "LIKED_EVENT_TAG",
                title: "Любимые теги",
                description: "Совпадение по тегам понравившихся событий"
            },
            {
                name: "LIKED_HISTORICAL_FIGURE",
                title: "Любимые исторические личности",
                description: "Историческая личность из интересов в событии"
            },
            {
                name: "LIKED_PLACE",
                title: "Любимые площадки",
                description: "Событие на понравившейся площадке"
            },
            {
                name: "PARTIAL_AUTHOR_MATCH",
                title: "Частично совпавшие авторы",
                description: "Автор события жил в одно время с выбранным автором (±20 лет)"
            },
        ],
    },
    {
        name: "increasing",
        title: "Увеличивающие",
        items: [
            {
                name: "PRIZES",
                title: "Награды и премии",
                description: "Бонус за количество наград у события"
            },
            /*{
                name: "???",
                title: "???",
                description: "Премьера (новое событие)"
            },*/
            /*{
                name: "???",
                title: "???",
                description: "к-во месяцев премьеры"
            },*/
        ],
    },
];